import { useEffect, useState } from "react";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
const InstallButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    });
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      console.log("App installed");
      setShowInstall(false);
    } else {
      console.log("App install dismissed");
    }
    setDeferredPrompt(null);
  };

  return (
    <>
      {showInstall && (
        <div id="install-button" className="install-button">
          <a onClick={handleInstallClick}>
            <ArrowCircleDownIcon
              sx={{ cursor: "pointer", fill: "#fff", fontSize: 28 }}
            />
          </a>
        </div>
      )}
    </>
  );
};

export default InstallButton;
